import {NEW_JB} from 'actions/jewelryBox';

export default (state = null, action) => {
    switch (action.type) {
        case NEW_JB:
            return action.payload.data;

    }
    return state;
}